export default __webpack_public_path__ + "static/media/bg3.19399956.jpg";